import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { ABOUT_COMPANY_HISTORY_NAMES, LIST_OF_KEY_EVENTS_FIELDS } from 'components/BusinessToolForm/Sections/AboutCompany/CompanyHistory/utils/form';
import { ABOUT_COMPANY_GENERAL_NAMES, LIST_OF_FOUNDERS_FIELDS } from 'components/BusinessToolForm/Sections/AboutCompany/GeneralInfo/utils/form';
import { ABOUT_COMPANY_MISSION_NAMES, GOAL_ROW_NAMES } from 'components/BusinessToolForm/Sections/AboutCompany/MissionAndVision/utils/form';
import { ABOUT_COMPANY_SWOT_NAMES, SWOT_ROW_NAMES } from 'components/BusinessToolForm/Sections/AboutCompany/SWOT/utils/form';

import { ul } from '../helpers';

const SOCIAL_NETWORKS_INSTRUCTION_TEXT =
  'Listen Sie die sozialen Netzwerke auf, die Ihr Unternehmen nutzt, zusammen mit den jeweiligen Links. Stellen Sie sicher, dass alle Links korrekt sind und zu Ihren offiziellen Profilen führen.';
const FOUNDERS_INSTRUCTION_TEXT =
  "Bitte geben Sie eine umfassende Liste der Gründer Ihres Unternehmens an. Fügen Sie ihre vollständigen Namen hinzu und geben Sie den prozentualen Eigentumsanteil jedes Gründers an.";

const LIST_OF_FOUNDERS_INSTRUCTIONS = {
  [LIST_OF_FOUNDERS_FIELDS.FIRST_NAME]: {
    name: 'Vorname',
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [LIST_OF_FOUNDERS_FIELDS.LAST_NAME]: {
    name: 'Nachname',
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [LIST_OF_FOUNDERS_FIELDS.SHARE_IN_COMPANY]: {
    name: 'Gründerliste',
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
};

const GENERAL_INFO_INSTRUCTIONS = {
  [ABOUT_COMPANY_GENERAL_NAMES.LEGAL_STRUCTURE]: {
    name: 'Rechtsform',
    instruction:
      'Geben Sie die Rechtsform Ihres Unternehmens an. Optionen umfassen: Einzelunternehmen, Personengesellschaft, Kapitalgesellschaft oder Gesellschaft mit beschränkter Haftung (GmbH).',
    exampleOne: 'Gesellschaft mit beschränkter Haftung',
    exampleTwo: 'Einzelunternehmen',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.WEBSITE_URL]: {
    name: 'Webseite',
    instruction: 'Geben Sie die vollständige Webadresse Ihres Unternehmens an',
    exampleOne: 'agrotech.com',
    exampleTwo: 'languagelab.com',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.PHONE]: {
    name: 'Telefon',
    instruction:
      'Geben Sie eine zuverlässige Telefonnummer Ihres Unternehmens an, einschließlich Vorwahl und ggf. Durchwahl.',
    exampleOne: '+1 484 111 11 11',
    exampleTwo: '+1 584 741 21 82',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.EMAIL]: {
    name: 'E-Mail',
    instruction:
      'Geben Sie die offizielle E-Mail-Adresse des Unternehmens korrekt an, einschließlich Domain und relevanter Kontaktangaben.',
    exampleOne: 'info@agrotech.com',
    exampleTwo: 'info@languagelab.com',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.FACEBOOK]: {
    name: 'Facebook',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: 'www.facebook.com/agrotech/',
    exampleTwo: 'www.facebook.com/languagelab/',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.LINKEDIN]: {
    name: 'LinkedIn',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.INSTAGRAM]: {
    name: 'Instagram',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.OTHER]: {
    name: 'Andere soziale Netzwerke',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  // TODO add the names here
  [ABOUT_COMPANY_GENERAL_NAMES.FIRST_NAME]: {
    name: 'Vorname',
    instruction:
      'Geben Sie den vollständigen gesetzlichen Namen der Hauptansprechperson an. Überprüfen Sie Schreibweise und Format sorgfältig.',
    exampleOne: 'John',
    exampleTwo: 'Sam',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.LAST_NAME]: {
    name: 'Nachname',
    instruction:
      'Geben Sie den vollständigen gesetzlichen Namen der Hauptansprechperson an. Überprüfen Sie Schreibweise und Format sorgfältig.',
    exampleOne: 'Johnson',
    exampleTwo: 'Doe',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.POSITION]: {
    name: 'Position',
    instruction:
      'Geben Sie die offizielle Berufsbezeichnung in Ihrem Unternehmen an. Präzisieren Sie, ob die Kontaktperson Eigentümer, Berater oder eine andere Funktion innehat.',
    exampleOne: 'CEO, Gründer',
    exampleTwo: 'CFO',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_EMAIL]: {
    name: 'E-Mail',
    instruction:
      'Geben Sie die offizielle E-Mail-Adresse der Hauptansprechperson korrekt an, einschließlich Domain und relevanter Kontaktangaben.',
    exampleOne: 'ceo@agrotech.com',
    exampleTwo: 'ceo@languagelab.com',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_PHONE]: {
    name: 'Kontakttelefonnummer',
    instruction:
      'Geben Sie eine zuverlässige Telefonnummer der Hauptansprechperson an, einschließlich Vorwahl und ggf. Durchwahl.',
    exampleOne: '+1 484 111 11 11',
    exampleTwo: '+1 464 111 35 93',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.LIST_OF_FOUNDERS]: LIST_OF_FOUNDERS_INSTRUCTIONS,
};

const LIST_OF_KEY_EVENTS_FIELDS_INSTRUCTIONS = {
  [LIST_OF_KEY_EVENTS_FIELDS.TITLE]: {
    name: 'Wichtige historische Ereignisse',
    instruction:
      'Stellen Sie kurz die Gründung Ihres Unternehmens und frühe Meilensteine vor, einschließlich der Marktlücke, die zur Gründung führte. Heben Sie erste Erfolge wie Registrierung, Lizenzierung oder Prototypentwicklung hervor.',
    exampleOne:
      'Im Jahr 2020 brachte das Unternehmen sein erstes Ketten-Traktormodell auf den Markt, das die Landwirtschaft auf schwierigen Böden durch bessere Traktion und Bodenschonung revolutionierte.',
    exampleTwo:
      'Im Jahr 2021 führte die Sprachplattform ihre KI-gestützte Übersetzungsfunktion ein, die die mehrsprachige Kommunikation revolutionierte.',
  },
  [LIST_OF_KEY_EVENTS_FIELDS.DATE]: {
    name: 'Datum',
    instruction: 'Geben Sie das Datum des Ereignisses genau an, einschließlich Monat und Jahr',
    exampleOne: '',
    exampleTwo: '',
  },
};

const COMPANY_HISTORY_INSTRUCTIONS = {
  [ABOUT_COMPANY_HISTORY_NAMES.BUSINESS_IDEA_CONCEPTION]: {
    name: 'Ursprung der Geschäftsidee',
    instruction:
      'Beschreiben Sie die Entstehung der Geschäftsidee: Umstände, Herausforderungen und Beobachtungen, die das Konzept ausgelöst haben. Erläutern Sie Marktlücken, Trends oder persönliche Erfahrungen, die zur Chance führten.',
    exampleOne:
      'Die Geschäftsidee entstand aus John Johnsons persönlicher Erfahrung mit schweren oder nassen Böden, die die Leistung herkömmlicher Traktoren beeinträchtigten. Gemeinsam mit Oliver Smith erkannte er die Chance, Ketten-Traktoren mit besserer Traktion und Bodenschonung zu entwickeln.',
    exampleTwo:
      'Die Idee für die Plattform entstand aus der chaotischen und unsystematischen Struktur des Übersetzungsmarktes, in dem Kunden Schwierigkeiten hatten, geeignete Fachkräfte zu finden und deren Kompetenz zu prüfen.',
  },
  [ABOUT_COMPANY_HISTORY_NAMES.MOTIVATION]: {
    name: 'Gründungsmotivation',
    instruction:
      'Formulieren Sie klar den Hauptzweck der Geschäftsidee. Geben Sie die Motivation und die Ziele an, die dieses Konzept inspiriert haben, und betonen Sie den positiven Einfluss oder die angestrebte Veränderung.',
    exampleOne:
      'Das Unternehmen wurde gegründet, um eine Marktlücke im Bereich spezialisierter Traktoren für schwere oder nasse Böden zu schließen.',
    exampleTwo:
      'Die Plattform verbindet Übersetzer und Kunden und bietet eine effiziente, sichere und transparente Lösung für hochwertige Übersetzungen.',
  },
  [ABOUT_COMPANY_HISTORY_NAMES.EVENTS]: LIST_OF_KEY_EVENTS_FIELDS_INSTRUCTIONS,
};

const GOALS_INSTRUCTIONS = {
  [GOAL_ROW_NAMES.GOAL]: {
    name: 'Ziel',
    instruction:
      'Beschreiben Sie die strategischen Unternehmensziele und betonen Sie kurz-, mittel- und langfristige Prioritäten im Einklang mit Mission und Vision.',
    exampleOne:
      'Langfristig: Globale Marktführerschaft durch Diversifizierung der Produktpalette, Investitionen in nachhaltige Agrartechnologien und Expansion in Schwellenmärkte.',
    exampleTwo:
      'Kurzfristig: Verbesserung der Benutzerfreundlichkeit der Plattform und Erweiterung der Nutzerbasis durch gezielte Marketingkampagnen.',
  },
  [GOAL_ROW_NAMES.PRIORITY]: {
    name: 'Priorität',
    instruction: 'Geben Sie die Priorität des Ziels kurz an: hoch, mittel oder niedrig.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GOAL_ROW_NAMES.TERMS]: {
    name: 'Zeithorizont',
    instruction: 'Geben Sie kurz an, ob es sich um ein kurz- oder langfristiges Ziel handelt.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GOAL_ROW_NAMES.SCHEDULED_DATE]: {
    name: 'Geplantes Datum',
    instruction: 'Geben Sie das Datum des Ziels genau an, einschließlich Monat und Jahr.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GOAL_ROW_NAMES.MECHANISM_OF_ACHIEVEMENT]: {
    name: 'Umsetzungsmechanismus',
    instruction:
      'Beschreiben Sie die Mechanismen und Strategien zur Erreichung der Ziele, einschließlich konkreter Initiativen, Maßnahmen und operativer Rahmenbedingungen.',
    exampleOne:
      'Produktdiversifizierung, Investitionen in nachhaltige Agrartechnologie und Expansion in neue Märkte zur langfristigen Wettbewerbsfähigkeit.',
    exampleTwo:
      'Einführung eines Nutzer-Feedback-Systems zur Priorisierung von Funktionen und gezielte digitale Marketingkampagnen zur Nutzergewinnung.',
  },
};

const MISSION_NAMES_INSTRUCTIONS = {
  [ABOUT_COMPANY_MISSION_NAMES.VISION_OF_FUTURE]: {
    name: 'Vision',
    instruction:
      'Formulieren Sie die langfristigen Ziele des Unternehmens und deren positiven Einfluss auf Branche oder Gesellschaft. Stimmen Sie die Vision mit den Kernwerten ab.',
    exampleOne:
      'Die Vision des Unternehmens ist es, die Landwirtschaft durch innovative Traktorlösungen in eine technologisch fortschrittliche Zukunft zu führen.',
    exampleTwo:
      'Die Vision des Unternehmens ist es, die Sprachdienstleistungsbranche durch innovative Technologie und ethische Standards anzuführen.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.CORE_VALUES]: {
    name: 'Unternehmenswerte',
    instruction:
      'Beschreiben Sie die zentralen Werte des Unternehmens, die Kultur, Entscheidungen und Mitarbeiterverhalten prägen.',
    exampleOne:
      'Die Kernwerte des Unternehmens sind Innovation, Integrität und Nachhaltigkeit, die eine Kultur der Verantwortung fördern.',
    exampleTwo:
      'Die Sprachplattform legt Wert auf Inklusivität, Genauigkeit und Nutzerorientierung.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.PROBLEM_OF_MARKET]: {
    name: 'Problemdefinition',
    instruction:
      'Beschreiben Sie das Marktumfeld, bestehende Herausforderungen und die spezifische Marktlücke, die Ihr Unternehmen adressiert.',
    exampleOne:
      'Herkömmliche Radtraktoren kämpfen auf schweren Böden mit mangelhafter Traktion und Bodenverdichtung, was Produktivität und Erträge reduziert.',
    exampleTwo:
      'Der Sprachdienstleistungsmarkt ist ineffizient und dezentralisiert, was zu Verzögerungen und Kommunikationsproblemen führt.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.HOW_PROJECT_ADDRESSES_THE_PROBLEM]: {
    name: 'Beitrag zur Problemlösung',
    instruction:
      'Beschreiben Sie die zentralen Elemente Ihrer Lösung, den strategischen Ansatz und die Vorteile für die Zielgruppen.',
    exampleOne:
      'Der Geschäftsplan konzentriert sich auf spezialisierte Ketten-Traktoren mit patentierter Technologie, die Produktivitätsprobleme auf schweren Böden lösen.',
    exampleTwo:
      'Das Unternehmen löst die Dezentralisierung der Sprachdienste durch eine zentrale Plattform, sichere Zahlungen und KI-gestützte Prozesse.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.GOALS]: GOALS_INSTRUCTIONS,
};

const SWOT_OPPORTUNITIES_INSTRUCTIONS = {
  [SWOT_ROW_NAMES.TITLE]: {
    name: 'Chancen',
    instruction:
      'Analysieren Sie Markttrends und identifizieren Sie Chancen, die zu den Stärken des Unternehmens passen.',
    exampleOne: ul([
      'Expansion in Schwellenmärkte mit wachsender Nachfrage nach spezialisierter Landtechnik.',
      'Diversifizierung des Produktportfolios durch ergänzende Geräte und Zubehör.',
      'Partnerschaften mit Forschungseinrichtungen zur Entwicklung neuer landwirtschaftlicher Technologien.',
    ]),
    exampleTwo: ul([
      'Erweiterung um Funktionen für mündliche und simultane Übersetzung.',
      'Nutzung von KI und Machine-Learning zur Verbesserung der Plattformfunktionen.',
      'Expansion in internationale Märkte mit wachsender Nachfrage nach Übersetzungsdiensten.',
    ]),
  },
};

const SWOT_THREATS_INSTRUCTIONS = {
  [SWOT_ROW_NAMES.TITLE]: {
    name: 'Bedrohungen',
    instruction:
      'Identifizieren und analysieren Sie externe Bedrohungen wie Markttrends, Konkurrenz, wirtschaftliche Abschwünge oder regulatorische Risiken.',
    exampleOne: ul([
      'Zunehmender Wettbewerb durch große, etablierte Hersteller mit mehr Ressourcen.',
      'Regulatorische Veränderungen, die den Einsatz von Landmaschinen betreffen.',
      'Technologische Innovationen von Wettbewerbern mit alternativen Lösungen.',
    ]),
    exampleTwo: ul([
      'Cyberrisiken aufgrund der Abhängigkeit von digitalen Plattformen.',
      'Wirtschaftliche Abschwünge oder Währungsschwankungen beeinflussen die Ausgabebereitschaft der Kunden.',
      'Neue Wettbewerber oder disruptive Technologien gefährden Marktanteile.',
    ]),
  },
};

const SWOT_INSTRUCTIONS = {
  [ABOUT_COMPANY_SWOT_NAMES.OPPORTUNITIES]: SWOT_OPPORTUNITIES_INSTRUCTIONS,
  [ABOUT_COMPANY_SWOT_NAMES.THREATS]: SWOT_THREATS_INSTRUCTIONS,
};

export const ABOUT_COMPANY_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.GENERAL_INFO]: GENERAL_INFO_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.COMPANY_HISTORY]: COMPANY_HISTORY_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.MISSION_AND_STRATEGY]: MISSION_NAMES_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.SWOT]: SWOT_INSTRUCTIONS,
};
